import { CoursePreviewPageController } from './course-preview-page.controller';
import { CoursePreviewPageProps } from './course-preview-page.model';

export const CoursePreviewPage = (props: CoursePreviewPageProps) => {
  return <CoursePreviewPageController {...props} />;
};
